import React from "react"
import { Link } from "react-router-dom"
import { Field } from "formik"

import CatchCard from "~/library/CatchCard"

import * as Yup from "yup"
import FormikWrapper from "~/library/FormikWrapper"
import FormikInput from "~/library/FormikInput"
import Category from "~/types/Category"

const categorySchema = Yup.object({
  name: Yup.string().required("Category name is required"),
  active: Yup.boolean(),
})

interface CategoryFormProps {
  onSubmit: (values: any) => void
  initialValues?: Category
  isEditing?: boolean
}

const CategoryForm: React.FC<CategoryFormProps> = ({
  onSubmit,
  initialValues,
  isEditing = false,
}) => {
  const defaultValues = {
    name: "",
    active: true,
  }

  const handleFormSubmit = (values: Category) => {
    const formData = {
      name: values.name,
      active: values.active,
    }
    onSubmit(formData)
  }

  return (
    <FormikWrapper
      onSubmit={handleFormSubmit}
      validationSchema={categorySchema}
      initialValues={isEditing ? initialValues : defaultValues}
    >
      <CatchCard>
        <FormikInput
          name="name"
          label="Category Name"
          placeholder="Food & Beverage"
          required
          helpText=""
        />

        <div className="mb-3">
          <Field name="active">
            {({ field }: any) => (
              <div className="form-check">
                <input
                  {...field}
                  type="checkbox"
                  className="form-check-input"
                  id="active"
                  checked={field.value}
                />
                <label htmlFor="active" className="form-check-label">
                  Active
                </label>
                <div className="form-text">
                  When active, this category will be available for line items
                </div>
              </div>
            )}
          </Field>
        </div>
      </CatchCard>

      <div className="d-flex">
        <div className="ms-auto">
          <Link className="btn btn-secondary me-2" to="/categories">
            Cancel
          </Link>
          <button type="submit" className="btn btn-primary">
            {isEditing ? "Update Category" : "Create Category"}
          </button>
        </div>
      </div>
    </FormikWrapper>
  )
}

export default CategoryForm
